/** Shared “press space for next word” cue (dictation, flash, sprint, checkpoint). */
export default function SpaceAdvanceHint({ zen = false }: { zen?: boolean }) {
  if (zen) {
    return (
      <p className="text-sm text-stone-500 dark:text-stone-400">
        <span className="font-mono text-base">␣</span> mellemrum — næste ord
      </p>
    );
  }
  return (
    <div className="dictation-space-hint flex flex-col items-center gap-1">
      <span className="inline-flex items-center gap-2 rounded-xl bg-emerald-100 px-4 py-2 text-sm font-semibold text-emerald-800 ring-1 ring-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-200 dark:ring-emerald-500/40">
        <span aria-hidden="true" className="font-mono text-lg">
          ␣
        </span>
        Tryk mellemrum for næste ord
      </span>
    </div>
  );
}
